import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { EXPENSE_CATEGORIES } from './ExpenseModal';

const categoryLabel = (value) => EXPENSE_CATEGORIES.find((c) => c.value === value)?.label || 'Other';

function ExpenseRow({ expense, canManage, onEdit, onDelete }) {
  const status = expense.status || 'paid';
  const isPaid = status === 'paid';
  const id = expense.expense_id;
  return (
    <div className="flex items-center justify-between gap-3 py-3 border-b last:border-b-0" data-testid={`expense-${id}`}>
      <div className="min-w-0">
        <p className="font-medium text-gray-800 truncate" data-testid={`expense-description-${id}`}>{expense.description}</p>
        <div className="flex flex-wrap items-center gap-2 mt-1">
          <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700" data-testid={`expense-category-${id}`}>
            {categoryLabel(expense.category)}
          </span>
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium ${isPaid ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}
            data-testid={`expense-status-badge-${id}`}
          >
            {isPaid ? 'Paid' : 'Planned'}
          </span>
          {expense.paid_by && (
            <span className="text-sm text-gray-600">{isPaid ? 'Paid by' : 'Paying'}: {expense.paid_by}</span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <p className="font-bold text-gray-800" data-testid={`expense-amount-${id}`}>${expense.amount.toFixed(2)}</p>
        {canManage && (
          <>
            <button onClick={() => onEdit(expense)} className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Edit expense" data-testid={`edit-expense-${id}`}>
              <FaEdit />
            </button>
            <button onClick={() => onDelete(expense)} className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Delete expense" data-testid={`delete-expense-${id}`}>
              <FaTrash />
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export function ExpenseList({ expenses, canManage, onAddExpense, onEdit, onDelete }) {
  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="expense-list">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800">Expenses</h3>
        <button onClick={onAddExpense} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm" data-testid="add-expense-btn">
          Add Expense
        </button>
      </div>
      {expenses.length === 0 ? (
        <p className="text-gray-600 text-center py-4">No expenses added yet</p>
      ) : (
        <div>
          {expenses.map((expense) => (
            <ExpenseRow key={expense.expense_id} expense={expense} canManage={canManage} onEdit={onEdit} onDelete={onDelete} />
          ))}
        </div>
      )}
    </div>
  );
}
